import api from './api';

// Settings › practice details, hospital practice numbers and email. Admin only.
// The SMTP password only travels one way: `password_set` comes back, never the password.
const settingsService = {
  practice: () => api.get('/settings/practice').then((r) => r.data.practice),
  savePractice: (practice) => api.put('/settings/practice', practice).then((r) => r.data.practice),
  hospitals: () => api.get('/settings/hospitals').then((r) => r.data.hospitals || []),
  setHospitalNumber: (hid, practiceNumber) => api.put(`/settings/hospitals/${hid}`, { practice_number: practiceNumber }).then((r) => r.data.hospital),

  email: () => api.get('/settings/email').then((r) => r.data),
  saveEmail: (config) => api.put('/settings/email', config).then((r) => r.data.config),
  // Resolves { success, error? } — a failed test is a result, not an exception.
  testEmail: (to) => api.post('/settings/email/test', { to }, { timeout: 60000 }).then((r) => r.data),
  emailLog: () => api.get('/settings/email/log').then((r) => r.data.entries || []),
};

export default settingsService;
